import React from 'react'
import cn, { Argument as ClassName } from 'classnames'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'

import { LandingMessage, LandingMessageType } from '../../../lib/landing-message'
import { LandingPageLayout } from '../../../lib/landing-page-layout'
import { theme } from '../../../lib/theme'
import Text from '../../../ui/Text'
import useText from '../../hooks/useText'

const Title = styled.div`
    font-size: 24px;
    padding-bottom: 20px;
`

export type ResetPasswordRequestErrorPageProps = {
    className?: ClassName
    style?: React.CSSProperties
}

export function ResetPasswordRequestErrorPage({
    className,
    style,
}: ResetPasswordRequestErrorPageProps): React.ReactElement {
    const text = useText()
    const navigate = useNavigate()
    return (
        <LandingPageLayout
            className={cn(className)}
            style={style}
            background={theme.whiteBackground}
            hideLanguageSelect
        >
            <LandingMessage
                linkText={text('lblReturnToSignIn')}
                onClick={() => navigate('/login', { replace: true })}
                type={LandingMessageType.ERROR}
            >
                <Title>
                    <Text code="lblSomethingWentWrong" />
                </Title>
                <Text code="lblSignUpError" />
            </LandingMessage>
        </LandingPageLayout>
    )
}
